import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { getUserData } from "../utils/authnicate";

/**
 * Create a new SPOC user.
 * POST api/SpocCreation/create-spoc
 *
 * Body: { userName, email, password, role, lobType, departments: string[], createdBy }
 */
export const createSpocAction = async (formData) => {
  const user = getUserData();

  // departments must be an array of strings
  const departments = Array.isArray(formData.departments)
    ? formData.departments
    : [];

  const payload = {
    userName: formData.employeeName?.trim() || "",
    email: formData.email?.trim() || "",
    password: formData.password?.trim() || "",
    role: formData.role?.trim() || "",
    lobType: formData.lob?.trim() || "",
    departments,
    createdBy: user?.email || user?.userName || "admin",
  };

  console.log("[createSpoc] → POST create-spoc | payload:", payload);

  try {
    const response = await apiClient.post(ATP_API_URL.SPOC_CREATE, payload);

    console.log("[createSpoc] ← response:", response?.status, response?.data);

    if (response?.status === 200 || response?.status === 201) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to create SPOC",
        };
      }
      return {
        success: true,
        message: response.data?.message || "SPOC created successfully",
        data: response.data,
      };
    }

    return { success: false, message: "Failed to create SPOC" };
  } catch (error) {
    console.error(
      "[createSpoc] Error:",
      error?.response?.data || error.message,
    );
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error.message ||
        "Failed to create SPOC",
    };
  }
};
